"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldVerticalSeparation = exports.ModelMutatorVerticalSeparation = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var unit_1 = require("../../../unit");
var collection_field_1 = require("../collection.field");
var ModelMutatorVerticalSeparation = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorVerticalSeparation, _super);
    function ModelMutatorVerticalSeparation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorVerticalSeparation.prototype.manual = function (newValue) {
        this.unlink();
        if (newValue == null || isNaN(newValue)) {
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            this.state.setFieldValue(this.field.id, {
                value: newValue
            });
        }
    };
    ModelMutatorVerticalSeparation.prototype.clear = function () {
        this.manual(null);
    };
    ModelMutatorVerticalSeparation.prototype.drawable = function (drawable) {
        var stateValue = this.field.stateValue;
        if (this.field.hasDrawableTop()) {
            this.state.setFieldValue(this.field.id, {
                drawableBottom: drawable.id,
                drawableTop: stateValue.drawableTop,
                captureId: stateValue.captureId,
                value: stateValue.value
            });
        }
        if (this.field.hasDrawableBottom()) {
            return;
        }
        this.state.setFieldValue(this.field.id, {
            drawableTop: drawable.id,
            drawableBottom: '',
            captureId: drawable.captureId
        });
    };
    ModelMutatorVerticalSeparation.prototype.destroyState = function () {
        var drawableState = this.field.collection.getDrawableState(this.field.stateValue.captureId);
        drawableState.getDrawable(this.field.stateValue.drawableTop).destroy();
        if (this.field.hasDrawableBottom()) {
            drawableState.getDrawable(this.field.stateValue.drawableBottom).destroy();
        }
        this.state.setFieldValue(this.field.id, null);
    };
    ModelMutatorVerticalSeparation.prototype.unlink = function () {
        var stateValue = this.field.stateValue;
        if (stateValue == null || stateValue.drawableTop == null || stateValue.captureId == null) {
            return;
        }
        this.destroyState();
        var drawableState = this.field.collection.getDrawableState(stateValue.captureId);
        var drawableTop = drawableState.getDrawable(stateValue.drawableTop);
        drawableState.Mutator.unlink(drawableTop, this.field);
        if (stateValue.drawableBottom) {
            var drawableBottom = drawableState.getDrawable(stateValue.drawableBottom);
            drawableState.Mutator.unlink(drawableBottom, this.field);
        }
    };
    ModelMutatorVerticalSeparation.prototype.copy = function (from) {
        if (!from.stateValue) {
            this.clear();
            return true;
        }
        var fromCollection = from.collection;
        var toCollection = this.field.collection;
        var captureId = from.stateValue.captureId;
        var drawableTop = fromCollection.getDrawableState(captureId).getDrawable(from.stateValue.drawableTop);
        var drawableBottom = fromCollection.getDrawableState(captureId).getDrawable(from.stateValue.drawableBottom);
        if (fromCollection === toCollection) {
            // Link field to existing marker
            drawableTop.label.Mutator.link(this.field);
            this.drawable(drawableTop);
            drawableBottom.label.Mutator.link(this.field);
            this.drawable(drawableBottom);
            return true;
        }
        return false;
    };
    return ModelMutatorVerticalSeparation;
}(collection_field_1.ModelMutator));
exports.ModelMutatorVerticalSeparation = ModelMutatorVerticalSeparation;
var CollectionModelFieldVerticalSeparation = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldVerticalSeparation, _super);
    function CollectionModelFieldVerticalSeparation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldVerticalSeparation.isVerticalSeparationField = function (f) {
        return f.schema.type === CollectionModelFieldVerticalSeparation.TYPE;
    };
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorVerticalSeparation(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldVerticalSeparation.prototype.hasValue = function () {
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return false;
        }
        if (!stateValue.drawableTop || !stateValue.drawableBottom) {
            return false;
        }
        return true;
    };
    CollectionModelFieldVerticalSeparation.prototype.hasDrawableTop = function () {
        var stateValue = this.stateValue;
        if (stateValue == null || !stateValue.drawableTop) {
            return false;
        }
        return true;
    };
    CollectionModelFieldVerticalSeparation.prototype.hasDrawableBottom = function () {
        var stateValue = this.stateValue;
        if (stateValue == null || !stateValue.drawableBottom) {
            return false;
        }
        return true;
    };
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "value", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            if (this.drawableTop.value == null || this.drawableBottom.value == null) {
                return null;
            }
            return this.drawableTop.value - this.drawableBottom.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "drawable", {
        get: function () {
            var drawableState = this.collection.getDrawableState(this.stateValue.captureId);
            return drawableState.getDrawable(this.stateValue.drawableTop);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "drawableTop", {
        get: function () {
            var drawableState = this.collection.getDrawableState(this.stateValue.captureId);
            var d = drawableState.getDrawable(this.stateValue.drawableTop);
            return d;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "drawableBottom", {
        get: function () {
            var drawableState = this.collection.getDrawableState(this.stateValue.captureId);
            var d = drawableState.getDrawable(this.stateValue.drawableBottom);
            var top = drawableState.getDrawable(this.stateValue.drawableTop);
            top.state.pair = addPair(updatePair(top.state.pair), d.id);
            d.state.pair = addPair(updatePair(d.state.pair), top.id);
            return d;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "clearanceThresholdInMeters", {
        get: function () {
            return this.schema.clearanceThresholdInMeters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldVerticalSeparation.prototype, "annotationLabel", {
        get: function () {
            //if we're self-title no need to search for field just return displayname
            var fieldId = this.schema.annotationLabelFieldId;
            if (fieldId === this.schema.id) {
                return this.schema.displayName;
            }
            var field = this.findAncestorField(this.parent, fieldId);
            if (!field || !field.schema.type) {
                return this.parent.title;
            }
            switch (field.schema.type) {
                case core_api_1.IkeFieldType.ANCHOR:
                    // I think to get the complex values we have to type them first and put them together ourselves
                    if (field.hasValue()) {
                        var anchor = field.value;
                        return "".concat(anchor.collectionTool, " ").concat(anchor.placement);
                    }
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.DATE:
                    var date = field;
                    if (!date.hasValue() || date.displayValue == null || date.displayValue === '') {
                        return this.parent.title;
                    }
                    return date.displayValue;
                case core_api_1.IkeFieldType.FILE_TOOL:
                    var fileTool = field;
                    if (!fileTool.hasValue() || fileTool.displayValue == null || fileTool.displayValue === '') {
                        return this.parent.title;
                    }
                    return fileTool.displayValue;
                case core_api_1.IkeFieldType.FORM:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.HEIGHT:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.IMAGE:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.LOCATION:
                    var loc = field;
                    if (!loc.hasValue() || loc.displayValue == null || loc.displayValue === '') {
                        return this.parent.title;
                    }
                    var locVal = loc.value;
                    return "".concat(locVal.latitude.toFixed(2), ",").concat(locVal.longitude.toFixed(2));
                case core_api_1.IkeFieldType.NESTED_LIST:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.NUMBER:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.SELECT_LIST:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.TEXT:
                    if (!field.hasValue() || field.displayValue == null || field.displayValue === '') {
                        return this.parent.title;
                    }
                    return field.displayValue;
                case core_api_1.IkeFieldType.TRUE_SIZE:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.VECTOR:
                    var vector = field.value;
                    if (field.hasValue()) {
                        return "".concat(unit_1.IkeUnit.display(vector.distance, this.distanceUnit, unit_1.IkeUnit.METER, core_api_1.IkeUnitType.DISTANCE, 1), " ").concat(unit_1.IkeUnit.display(vector.bearing, unit_1.IkeUnit.DEGREE, unit_1.IkeUnit.RADIAN, core_api_1.IkeUnitType.ANGLE, 1));
                    }
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.VERTICAL_SEPARATION:
                    return field.schema.displayName;
                case core_api_1.IkeFieldType.YES_NO:
                    return field.schema.displayName;
                default:
                    return this.parent.title;
            }
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldVerticalSeparation.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldVerticalSeparation.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds().map(function (c) { return _this.collection.state.getCapture(c); }).filter(function (c) { return !!c; });
    };
    CollectionModelFieldVerticalSeparation.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldVerticalSeparation.prototype.getCaptureIds = function () {
        return [];
    };
    CollectionModelFieldVerticalSeparation.TYPE = core_api_1.IkeFieldType.VERTICAL_SEPARATION;
    return CollectionModelFieldVerticalSeparation;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldVerticalSeparation = CollectionModelFieldVerticalSeparation;
var updatePair = function (pair) {
    if (typeof pair === 'string') {
        return [pair];
    }
    return pair;
};
var addPair = function (pair, newPairedId) {
    if (pair == null) {
        return [newPairedId];
    }
    if (pair.includes(newPairedId)) {
        return pair;
    }
    return tslib_1.__spreadArray(tslib_1.__spreadArray([], pair, true), [newPairedId], false);
};
//# sourceMappingURL=vertical.separation.field.js.map